angular.module('main').filter(
	'timezoneFilter',
	() =>
		function(inputArray, type) {
			let output;

			if (!inputArray) {
				return [];
			}

			output = inputArray.map(obj => {
				let rObj, newValue, label;

				newValue = obj.value === 'Z' ? '00:00' : obj.value;
				label = `(${newValue}) ${obj.key.replace('/', ' - ')}`;

				rObj = {
					key: obj.key,
					label,
					value: newValue
				};

				return rObj;
			});

			return output;
		}
);



// WEBPACK FOOTER //
// ./web/js/services/filters/timezoneFilter.js